import React, { useState } from 'react';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase';
import toast from 'react-hot-toast';

const TempSuperAdminSetup = () => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const setupSuperAdmin = async () => {
    setLoading(true);
    try {
      console.log('🔧 Calling setSuperAdmin function...');
      
      const setSuperAdminFunction = httpsCallable(functions, 'setSuperAdmin');
      const response = await setSuperAdminFunction();
      
      console.log('✅ setSuperAdmin response:', response);
      setResult(response.data);
      toast.success('Super admin claims set successfully!');
      
      // Reload the page after a short delay to refresh auth state
      setTimeout(() => {
        window.location.reload();
      }, 2000);
      
    } catch (error) {
      console.error('❌ Error setting super admin claims:', error);
      setResult({ error: error.message });
      toast.error(`Failed to set super admin claims: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-md p-6">
        <h1 className="text-2xl font-bold text-gray-900 mb-6 text-center">
          🔧 Super Admin Setup
        </h1>
        
        <div className="mb-6">
          <p className="text-gray-600 mb-4">
            This will set Firebase Auth custom claims for <strong>chris@healehub.com</strong> to enable super admin access.
          </p>
          
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
            <h3 className="font-medium text-blue-900 mb-2">Claims to be set:</h3>
            <ul className="text-sm text-blue-700 space-y-1">
              <li>• role: 'super_admin'</li>
              <li>• permissions: ['admin_access', 'super_admin_access', 'tenant_management']</li>
              <li>• isSuperAdmin: true</li>
            </ul>
          </div>
        </div>

        <button
          onClick={setupSuperAdmin}
          disabled={loading}
          className={`w-full py-3 px-4 rounded-lg font-medium transition-colors ${
            loading
              ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
              : 'bg-blue-600 text-white hover:bg-blue-700'
          }`}
        >
          {loading ? '⏳ Setting Claims...' : '🚀 Set Super Admin Claims'}
        </button>

        {result && (
          <div className="mt-6 p-4 bg-gray-50 rounded-lg">
            <h3 className="font-medium text-gray-900 mb-2">Result:</h3>
            <pre className="text-sm text-gray-700 whitespace-pre-wrap">
              {JSON.stringify(result, null, 2)}
            </pre>
          </div>
        )}
      </div>
    </div>
  );
};

export default TempSuperAdminSetup;
